import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, of, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class CustomPreloadingStrategy implements PreloadingStrategy {
  
  // 定義需要預載入的關鍵頁面（減少數量，只保留最常用的）
  private preloadRoutes = [
    'home',          // 主頁
    'account',        // 用戶賬戶頁面
    'list-task',      // 任務列表頁面
    'category-page',   // 分類頁面
    'personal-finance', // 個人財務頁面
  ];

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    // 檢查路由路徑是否完全匹配預載入列表中的項目
    const shouldPreload = this.preloadRoutes.includes(route.path || '');

    if (shouldPreload) {
      // 添加延遲，避免阻塞初始載入
      return timer(2000).pipe(
        switchMap(() => {
          return load();
        })
      );
    }

    // 不預載入的路由
    return of(null);
  }
}
